<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-sm-12">
        <top-nav :page_title="page_title" v-bind:search_query="search"></top-nav>
        <FlashMessage :position="'right bottom'"></FlashMessage>
        <table class="table table-hover">
          <thead class="blue-gradient white-text">
          <tr>
            <th scope="col"><em><b>ID</b></em></th>
            <th scope="col"><em><b>SAMPLE SPECIES</b></em></th>
            <th scope="col"><em><b>SAMPLE TYPE</b></em></th>
            <th scope="col"><em><b>PROJECT</b></em></th>
            <th scope="col"><em><b>PROJECT OWNER</b></em></th>
            <th scope="col"><em><b>AVAILABLE AMOUNT</b></em></th>
            <th scope="col"><em><b>REQUESTED AMOUNT</b></em></th>
            <th scope="col"><em><b>ACTIONS</b></em></th>
          </tr>
          </thead>
          <tbody>
          <tr :key="requestedSample.id" v-for="(requestedSample, index) in this.requestedSampleList">
            <td> {{ index + 1 }}</td>
            <td v-if="requestedSample.animal_species"> {{ requestedSample.animal_species }}</td>
            <td v-else> N/A</td>
            <td v-if="requestedSample['type.name']"> {{ requestedSample['type.name'] }}</td>
            <td v-else> N/A</td>
            <td v-if="requestedSample['project.name']"> {{ requestedSample['project.name'] }}</td>
            <td v-else> N/A</td>
            <td v-if="requestedSample['project.lead.first_name']">
              {{ requestedSample['project.lead.first_name'] }} {{ requestedSample['project.lead.last_name'] }}</td>
            <td v-else> N/A</td>
            <td v-if="requestedSample.amount"> {{ requestedSample.amount }}</td>
            <td v-else> N/A</td>
            <td><div :id="`input_${index}`" ref="cells" contenteditable="true"
                     class="div-input" @focusin="clearDivError(index)"
                     @focusout="getNewDivData(index)">{{ requested_amount }} </div>
            </td>
            &nbsp;
            <b-icon
                @click="deleteSampleFromCart(requestedSample.code)"
                class="border rounded bg-danger p-1"
                :font-scale="`${font_scale}`" icon="trash"
                title="Delete" v-b-tooltip.hover
                variant="light"
            ></b-icon>
          </tr>
          </tbody>
        </table>


        <!-- MODAL FORM AS AN EXTERNAL COMPONENT -->
        <sample-request></sample-request>

        <!-- COMPLETE REQUEST BUTTON  -->
        <div class="d-flex justify-content-end" v-if="this.requestedSampleList.length !== 0">
          <b-button size="md" variant="primary" style="border-radius: 50%"
                    v-b-modal.modal-sample-request
                    @click="completeSampleOrder">
            Complete <br> Request</b-button>
        </div>

        <!-- DIV TO SHOW WHEN THERE ARE NO ITEMS IN THE CART -->
        <div class="d-flex justify-content-center" v-else>
          <h2>No Samples In Cart!</h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopNav from "@/components/TopNav";
import {font_scale} from '@/utils/constants';
import EventBus from "@/components/EventBus";
import SampleRequest from "@/forms/create/SampleRequest";
import {clearDivError, getCartItems, getNewDivData, getSamples, showFlashMessage} from "@/utils/util_functions";

export default {
  name: "CartView",
  data (){
    return {
      sampleList: [],
      requestedSampleList: [],
      cartItems: [],
      page_title: 'Cart View',
      search: null, font_scale,
      requested_amount: 0, div_errors: true
    }
  },

  mounted() {
    EventBus.$on('new-div-data', payload => {
      let index = payload['index']
      if (this.requestedSampleList[index] !== undefined){
        this.requestedSampleList[index].requestedAmount = payload['cellValue']
        if (this.requestedSampleList[index].requestedAmount > this.requestedSampleList[index].amount){
          this.requestedSampleList[index].requestedAmount = 0

          // set error on the div
          document.getElementById('input_'+index).textContent = 'value is greater than available amount';
          document.getElementById('input_'+index).style.backgroundColor = 'red';
        }
      }
    })
  },

  methods: {
    /**
       function takes all the samples available from the list sample view, searches through them filtering out the
     ones found in the cart using their code.
    **/
    filterSamplesInCart(){
      this.sampleList = getSamples()
      this.cartItems = getCartItems()

      for(let i=0; i < this.sampleList.length; i++){
        for(let j=0; j < this.cartItems.length; j++){
          if (this.sampleList[i].code === this.cartItems[j]){
            this.requestedSampleList.push(this.sampleList[i])
          }
        }
      }
    },

    // util functions
    getNewDivData, clearDivError,

    deleteSampleFromCart(code){
      for (let i=0; i < this.cartItems.length; i++){
        if ( this.cartItems[i] === code) {
          this.cartItems.splice(i, 1);
          this.requestedSampleList.splice(i, 1);
        }
      }
    },

    completeSampleOrder(){
      /* validation;
      * Check through the list of the requested samples if each sample requested amount reaches a certain criteria
      * defined in the if condition otherwise raise error in that specific <div> element and return i.e. exit the loop
      * on error
      *
      * If the above validation passes set dev_error flag to false and emit an event with samples and
      * form validity status i.e. `formValid` which is used by the SampleRequest component to determine whether
      * or not to show the modal box.*/
      for (let j=0; j < this.requestedSampleList.length; j++){
        if (this.requestedSampleList[j].requestedAmount === this.requested_amount ||
                isNaN(this.requestedSampleList[j].requestedAmount) ||
        typeof this.requestedSampleList[j].requestedAmount !== 'number'){
          this.div_errors = true
          document.getElementById('input_'+j).textContent = 'error!!!';
          document.getElementById('input_'+j).style.backgroundColor = 'red';
          showFlashMessage(this, 'error', 'Required Amount', 'Please input amount you are requesting')
          return;
        }
      }
      this.div_errors = false;
      EventBus.$emit('complete-batch-sample-order', {'samples':this.requestedSampleList, 'formValid':true})
    }
  },

  created() {
    this.filterSamplesInCart()
  },

  components: {TopNav, SampleRequest}
}
</script>